import { CreateDcddMembershipPlanInput, CreateDcddMembershipPlanInputError } from "../../store/actionType";

export const FormValidation = (
  data: CreateDcddMembershipPlanInput
): CreateDcddMembershipPlanInputError => {
  const errors: CreateDcddMembershipPlanInputError = {};
  if (!data.end_date) {
    errors.end_date = "End date is required";
  } 
  if (!data.membership_plan) {
    errors.membership_plan = "Please enter a DCDD membership plan";
  } 
  if (!data.user_limit) {
    errors.user_limit = "Please enter user limit";
  } 
  if (!data.remarks) {
    errors.remarks = "Remarks is required";
  } 
  return errors;
};